import * as React from "react";
import { RichTextInput } from "ra-input-rich-text";
import {
  SimpleForm,
  TextInput,
  Create,
  CreateProps,
  BooleanInput,
} from "react-admin";

import { Box, Card, CardMedia } from "@mui/material";
import { validateOptionalUrl } from "../../../constants";

export const CreatePost: React.FC<CreateProps> = (props) => {
  const [previewImage, setPreviewImage] = React.useState("");
  const handleImageChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setPreviewImage(event.target.value);
    },
    []
  );

  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="title" label="Título" fullWidth required />
        <TextInput source="slug" disabled fullWidth />
        <Box sx={{ display: "flex", gap: "16px" }}>
          <BooleanInput source="isPublished" label="Publicado" />
          <BooleanInput source="isHighlighted" label="Destacado" />
        </Box>
        <TextInput
          source="previewImage"
          label="Imagen de portada"
          fullWidth
          onChange={handleImageChange}
          validate={validateOptionalUrl}
        />
        {previewImage && (
          <Card
            sx={{
              margin: "16px auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CardMedia
              component="img"
              alt={`Vista previa de imagen de portada: ${previewImage}`}
              image={previewImage}
              width="100%"
            />
          </Card>
        )}
        <RichTextInput source="content" fullWidth label="Contenido" />
      </SimpleForm>
    </Create>
  );
};
